/**
 * Select2 informal German translation
 */
define('lib/select2_locale_de_informal',['controller', 'lib/select2.min'], function(controller) {
	$.fn.select2.locales['de_informal'] = {
		formatNoMatches : function() {
			return "Keine Übereinstimmungen gefunden";
		},
		formatInputTooShort : function(input, min) {
			var n = min - input.length;
			return "Bitte " + n + " Zeichen mehr eingeben";
		},
		formatInputTooLong : function(input, max) {
			var n = input.length - max;
			return "Bitte " + n + " Zeichen weniger eingeben";
		},
		formatSelectionTooBig : function(limit) {
			return "Du kannst nur " + limit + " Eintr"	+ (limit === 1 ? "ag" : "äge") + " auswählen";
		},
		formatLoadMore : function(pageNumber) {
			return "Lade mehr Ergebnisse…";
		},
		formatSearching : function() {
			return "Suche…";
		},
		formatMatches : function(matches) {
			return matches
					+ " Ergebnis "
					+ (matches > 1 ? "se" : "")
					+ " verfügbar, zum Navigieren die Hoch-/Runter-Pfeiltasten verwenden.";
		}
	};
	
	$.extend($.fn.select2.defaults, $.fn.select2.locales['de_informal']);
});

